// CLARTEXT · /abo · B2-B/B2-E2 — Chris als Seitenführer (in-flow).
//
// Streng nach den eingefrorenen Chris-Regeln:
//  - ausschließlich FROZEN Production-Assets aus Character Master v1.1.
//    B2-E2 (Betreiber-GO 4b): zusätzlich zu 21/22/23 die Kommentar-Posen
//    10 / 13 / 17 / 19 (D2 §16). KEINE Spiegelung, KEINE neue Grafik.
//  - in-flow im normalen Seitenfluss (KEIN Viewport-Overlay, keine absolute
//    Positionierung über Screenshots/Buttons), pointer-events:none.
//  - Chris trägt Information: die Sprechblase übersetzt genau EINEN Nutzen
//    des sichtbaren Produktbeweises und bleibt für Screenreader lesbar; nur
//    die Figur ist dekorativ (aria-hidden).
const POSES = {
  6: "/chris/v1_1/production/06_chris_arrive.png",
  8: "/chris/v1_1/production/08_chris_point.png",
  10: "/chris/v1_1/production/10_chris_thumbs_up.png",
  13: "/chris/v1_1/production/13_chris_stand_point_left.png",
  14: "/chris/v1_1/production/14_chris_stand_point_right.png",
  15: "/chris/v1_1/production/15_chris_stand_point_down.png",
  16: "/chris/v1_1/production/16_chris_stand_point_up.png",
  17: "/chris/v1_1/production/17_chris_stand_present.png",
  18: "/chris/v1_1/production/18_chris_sit_present.png",
  19: "/chris/v1_1/production/19_chris_stand_explain.png",
  21: "/chris/v1_1/production/21_chris_intro_greeting.png",
  22: "/chris/v1_1/production/22_chris_think_check.png",
  23: "/chris/v1_1/production/23_chris_present_explain.png",
};

export default function AboChris({ pose, text, testId, size = "md" }) {
  const src = POSES[pose];
  if (!src) return null;
  return (
    <div className={`abo-chris abo-chris-${size}`} data-testid={testId}>
      <img
        className="abo-chris-fig"
        src={src}
        alt=""
        aria-hidden="true"
        draggable="false"
        loading="lazy"
        data-testid={`${testId}-fig`}
      />
      {text ? (
        <div className="abo-chris-bubble" data-testid={`${testId}-bubble`}>
          <p>{text}</p>
        </div>
      ) : null}
    </div>
  );
}
